import { initializeApp } from 'firebase/app'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { useEmulators, firebaseConfig } from './config'

export const firebaseApp = initializeApp(firebaseConfig)

export const db = getFirestore(firebaseApp)
export const functions = getFunctions(firebaseApp, 'asia-east1')
export const storage = getStorage(firebaseApp)
export const auth = getAuth(firebaseApp)
if (useEmulators) {
  connectFirestoreEmulator(db, 'localhost', 5002)
  connectFunctionsEmulator(functions, 'localhost', 5001)
  connectStorageEmulator(storage, 'localhost', 9199)
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
}
